module.exports = __webpack_public_path__ + "img/auth.4d998506.jpg";